import { AutocompleteInput, ReferenceInput } from "react-admin";
import MuiDatePickerInput from "../../common/MuiDatePickerInput";

const costOfGoodsSoldFilterList = (permissions) => {
  const defaultFilter = [
    <MuiDatePickerInput
      alwaysOn
      source="date"
      variant="outlined"
      label="mine.label.start_date"
    />,
  ];
  if (permissions && permissions.update_company) {
    defaultFilter.splice(
      1,
      0,
      <ReferenceInput
        alwaysOn
        source="company_id"
        reference="companies"
        sort={{ field: "companies.alias", order: "ASC" }}
      >
        <AutocompleteInput
          resettable
          optionText="alias"
          variant="outlined"
          label="mine.label.company"
        />
      </ReferenceInput>
    );
  }
  return defaultFilter;
};
export default costOfGoodsSoldFilterList;
